import Radio from 'relements/build/esm/input/radio';
import Text from 'relements/build/esm/input/text';
import Dropdown from 'relements/build/esm/input/dropdown';
import { CHAT_ICON_CONFIG } from '@src/containers/BusinessManager/const';

import SDKChatIcon from '../../SDKChatIcon';

const JAVASCRIPT_SDK = {
  title: 'JS Configurations',
  inputs: [
    {
      label: 'Primary Color',
      key: 'primaryColor',
      component: Radio,
      props: {
        options: [
          { title: 'Custom Color', value: 'CUSTOM' },
          { title: 'Blue', value: '#3498db' },
          { title: 'Indigo', value: '#134696' },
          { title: 'Green', value: '#2ecc71' },
        ],
        tooltip:
          'This will define the color of chat button, header and chat bubbles',
      },
    },
    {
      label: 'Enter Hex Code',
      key: 'primaryColor2',
      component: Text,
      props: (value, onChange, form) => ({
        invisible: form.primaryColor !== 'CUSTOM',
        placeholder: form.primaryColor !== 'CUSTOM' ? 'N/A' : 'Hex Code',
      }),
    },
    {
      label: 'Chat Button Position',
      key: 'widgetPositioning',
      component: Radio,
      props: {
        options: [
          { title: 'Bottom Left', value: 'bottom-left' },
          { title: 'Bottom Right', value: 'bottom-right' },
          { title: 'Center', value: 'center' },
        ],
      },
    },
    {
      label: 'Width of Chat UI (Desktop)',
      key: 'mode',
      component: Radio,
      props: {
        options: [
          { title: 'Thin', value: 'ssm' },
          { title: 'Wide', value: 'overlay' },
        ],
      },
    },
    {
      label: 'User Input Method',
      key: 'botType',
      component: Radio,
      props: {
        options: [
          { title: 'Text Only', value: 'TEXT' },
          { title: 'Text + Voice', value: 'VOICE' },
          { title: 'Voice Only', value: 'VOICE_ONLY' },
        ],
      },
    },
    {
      label: 'Initial Input',
      key: 'voiceBotInitialInput',
      component: Radio,
      props: (value, onChange, form) => ({
        invisible: form.botType !== 'VOICE',
        options: [
          { title: 'Voice', value: 'VOICE' },
          { title: 'Keyboard', value: 'KEYBOARD' },
        ],
      }),
    },
    {
      label: 'Disable Features',
      key: 'disabled',
      component: Dropdown,
      props: {
        optionKey: 'title',
        options: [
          { title: 'Header', value: 'header' },
          { title: 'Typing Area', value: 'typingArea' },
          { title: 'Cross Button', value: 'crossButton' },
          { title: 'Chat Bubble', value: 'chatBubble' },
        ],
        searchKeys: ['title'],
        withSearch: true,
        withMultiple: true,
      },
    },
    {
      label: 'Bot Prompt Chat Icon',
      key: 'chatIconConfig',
      component: SDKChatIcon,
      props: (value, onChange, form) => ({
        primaryColor:
          form.primaryColor === 'CUSTOM'
            ? form.primaryColor2
            : form.primaryColor,
        options: [
          {
            label: 'Default',
            tooltip: '',
            type: CHAT_ICON_CONFIG.DEFAULT,
          },
          {
            label: 'Smile',
            tooltip: '',
            type: CHAT_ICON_CONFIG.SMILE,
          },
          {
            label: 'Help',
            tooltip: '',
            type: CHAT_ICON_CONFIG.HELP,
          },
          {
            label: 'Text',
            tooltip:
              'Please choose a Max 4 Letter word/line. We only allow 2 Lines ',
            type: CHAT_ICON_CONFIG.TEXT,
          },
          {
            label: 'Image/GIF',
            tooltip:
              'For an optimal experience, please choose an Image/gif that is 72px x 72px size and less than 5KB.',
            type: CHAT_ICON_CONFIG.IMAGE,
          },
        ],
      }),
    },
    {
      label: 'Chat Header Text',
      key: 'headerText',
      component: Text,
      props: {
        placeholder: 'Header Text',
        tooltip: 'This text will appear on the header of the chat UI',
      },
    },
    {
      label: 'Chat Button Text (Desktop)',
      key: 'buttonTextDesktop',
      component: Text,
      props: {
        placeholder: 'Button Text (Desktop)',
      },
    },
    {
      label: 'Chat Button Text (Mobile)',
      key: 'buttonTextMobile',
      component: Text,
      props: {
        placeholder: 'Button Text (Mobile)',
      },
    },
    {
      label: 'Font Family',
      key: 'fontFamily',
      component: Text,
    },
    {
      label: 'Hint Text on Typing Box',
      key: 'composerPlaceholder',
      component: Text,
      tooltip:
        'This text will appear on the footer of the chat UI to guide user to type a mesage',
    },
    {
      label: 'User Signup Required',
      key: 'customSignup',
      component: Radio,
      props: {
        options: [{ title: 'Yes', value: true }, { title: 'No', value: false }],
      },
    },
    {
      label: 'Enter Signup Identifier',
      key: 'customSignupIdentifier',
      component: Text,
      props: (value, onChange, form) => ({
        invisible: !form.customSignup,
        placeholder: !form.customSignup ? 'N/A' : 'Custom Signup Identifier',
      }),
    },
    {
      label: 'Custom Button',
      key: 'customButton',
      component: Radio,
      props: {
        options: [{ title: 'Yes', value: true }, { title: 'No', value: false }],
      },
    },
    {
      label: 'Enter Custom Button Identifier',
      key: 'customButtonIdentifier',
      component: Text,
      props: (value, onChange, form) => ({
        invisible: !form.customButton,
        placeholder: !form.customButton ? 'N/A' : 'DOM Id (#my-button)',
      }),
    },
    {
      label: 'Enable Typing Suggestions',
      key: 'enableTypingSuggestions',
      component: Radio,
      props: {
        options: [{ title: 'Yes', value: true }, { title: 'No', value: false }],
      },
    },
  ],
};

export default JAVASCRIPT_SDK;
